import React from 'react'
import _, { find, isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import Select from 'react-select'
import {
  ButtonContainer,
  Button,
  DetailList,
  ConversationItem,
  FormInputTextArea,
  Alert,
  FormInput
} from 'camino-react'

import { cloudhelpPatch, cloudhelpGet } from 'Utilities/CloudHelp'
import Modal from 'Components/Modal'
import Attachments from 'Components/Attachments'
import EditModal from './EditModal'

class ProblemDetails extends React.Component {
  constructor (props) {
    super(props)

    this.contentSections = ['Problem', 'Problem history log']

    this.state = {
      currentContentSectionTab: this.contentSections[0],
      showEditModal: false,
      creatorName: '',
      submitButton: {
        text: 'Save',
        disabled: false
      },
      errorMessage: '',
      errors: {},
      fields: {
        outcome: props.problem.outcome || '',
        preventive_action: props.problem.preventive_action || '',
        corrective_action: props.problem.corrective_action || '',
        root_cause: props.problem.root_cause || '',
        business_impact: props.problem.business_impact || '',
        issue: props.problem.issue || '',
        category_id: props.problem.category_id,
        datacentre_id: props.problem.datacentre_id,
        major_incident_manager_id: props.problem.major_incident_manager_id,
        problem_manager_id: props.problem.problem_manager_id,
      },
      priority: props.problem.priority || '',
      history: [],
      technicalEngineers: props.problem.technical_engineers || []
    }

    this.submit = this.submit.bind(this)
    this.collectCreator = this.collectCreator.bind(this)
    this.collectHistory = this.collectHistory.bind(this)
    this.setEditModalVisible = this.setEditModalVisible.bind(this)
  }

  componentDidMount () {
    const { problem } = this.props

    if (!_.isNil(problem.major_incident_manager_id)) {
      this.collectMajorIncidentManager()
    }

    this.collectCreator()
    this.collectHistory()
  }

  setFieldErrorClasses (field) {
    const { fieldsWithErrors } = this.state
    if (_.includes(fieldsWithErrors, field)) {
      return ('error')
    }

    return ''
  }

  setEditModalVisible (showEditModal) {
    this.setState({
      showEditModal,
      errors: {},
      errorMessage: ''
    })
  }

  handleInput = (fieldName, value) => {
    this.setState((prevState) => {
      const { fields } = prevState
      const newFields = Object.assign({}, fields, { [fieldName]: value })
      return (
        { fields: newFields }
      )
    })
  }

  showContentSection (currentContentSectionTab) {
    this.setState({ currentContentSectionTab })
  }

  submit () {
    const {
      priority,
      fields,
      technicalEngineers
    } = this.state

    const {
      issue,
      root_cause,
      business_impact,
      corrective_action,
      preventive_action,
      outcome,
      category_id,
      datacentre_id,
      major_incident_manager_id,
      problem_manager_id,
    } = fields

    const {
      setAlert,
      updateProblem,
      paths
    } = this.props
    const { problemPath, majorIncidentPath } = paths

    const postData = {
      problem: {
        priority: _.toLower(priority),
        issue,
        root_cause,
        business_impact,
        category_id,
        datacentre_id,
        corrective_action,
        preventive_action,
        outcome,
        major_incident_manager_id,
        problem_manager_id,
        technical_engineer_ids: map(technicalEngineers, 'value')
      }
    }

    this.setState({
      submitButton: {
        text: 'Saving...',
        disabled: true
      },
      errors: {},
      errorMessage: ''
    })

    cloudhelpPatch(problemPath, postData)
      .then((response) => {
        const { problem } = response.data

        this.setState({
          submitButton: {
            text: 'Save',
            disabled: false
          },
          showEditModal: false,
          errors: {},
          errorMessage: ''
        })

        setAlert(
          'Problem successfully updated',
          'success'
        )

        this.collectHistory()
        updateProblem(problem)

        if (problem.priority === 'p1' && _.isNil(problem.major_incident_manager_id)) {
          window.location = majorIncidentPath
        }
      })
      .catch((error) => {
        this.setState({
          submitButton: {
            text: 'Save',
            disabled: false
          },
          errorMessage: 'Please fill in the required fields',
          errors: error.response.data.errors
        })
      })
  }

  currentContentSectionTabClass (type) {
    const { currentContentSectionTab } = this.state

    if (currentContentSectionTab === type) {
      return 'content-section__header-tab--active'
    }

    return ''
  }

  collectMajorIncidentManager () {
    const { problem } = this.props

    cloudhelpGet(`/api/users/${problem.major_incident_manager_id}`)
      .then((response) => {
        const user = response.data

        this.setState({ managerName: user.name })
      })
  }

  collectCreator () {
    const { problem } = this.props

    cloudhelpGet(`/api/users/${problem.creator_id}`)
      .then((response) => {
        const user = response.data

        this.setState({ creatorName: user.name })
      })
  }

  handlePriorityChange (event) {
    this.setState({ priority: event.value })
  }

  collectHistory () {
    const { problem } = this.props

    this.setState({
      loading: true
    })

    cloudhelpGet(`/api/problems/${problem.id}/history`)
      .then((response) => {
        this.setState({ history: response.data, loading: false })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  render () {
    const {
      currentContentSectionTab,
      showEditModal,
      creatorName,
      managerName,
      priority,
      fields,
      errors,
      errorMessage,
      submitButton,
      history,
      technicalEngineers,
      problem_manager_id
    } = this.state

    const {
      open,
      problemAdmin,
      problem,
      priorities,
      hidden,
      policy,
      policies,
      categories,
      majorIncidentManagers,
      managers,
      usersOptions,
      datacentres
    } = this.props

    const canEditProblem = open && policy('problem', 'edit')

    const contentSectionHeaderTabs = _.map(this.contentSections, sectionName => (
      <button
        type="button"
        style={{ outline: 'none' }}
        className={`content-section__header-tab ${this.currentContentSectionTabClass(sectionName)}`}
        key={sectionName}
        onClick={() => this.showContentSection(sectionName)}
      >
        {sectionName}
      </button>
    ))

    const problemDetails = [
      {
        title: 'Major incident manager',
        content: (problem.managerName || 'No Major Incident Manager set')
      },
      {
        title: 'Created',
        content: moment(problem.created_at).format('DD MMM YYYY, hh:mmA')
      },
      {
        title: 'Problem Manager',
        content: problem.problem_manager_name || 'No Manager set'
      },
      {
        title: 'Technical Engineers',
        content: !isEmpty(problem.technical_engineers) ? (
          <div>
            {map(problem.technical_engineers, engineer => (
              <div>{engineer.label}</div>
            ))}
          </div>
        ) : 'No Technical Engineers set'
      },
      {
        title: 'Priority',
        content: problem.priority
      },
      {
        title: 'Datacentre Location',
        content: problem.datacentre_location || 'No Datacentre location set'
      },
      {
        title: 'Status',
        content: (
          <span className={`pill ${problem.status === 'Open' ? 'pill--red' : 'pill--green'}`}>
            {problem.status}
          </span>
        )
      }
    ]
    const addActionContent = (content, actionPolicy) => (
      actionPolicy || (canEditProblem && (
        <button
          color="primary"
          type="button"
          onClick={() => this.setEditModalVisible(true)}
          className="button-link link link--decorated"
        >
          {content}
        </button>
      ))
    )
    const problemActionDetails = [
      {
        title: 'Issue',
        content: problem.issue
      },
      {
        title: 'Root cause',
        content: addActionContent('Add root cause', problem.root_cause)
      },
      {
        title: 'Business Impact',
        content: addActionContent('Add business impact', problem.business_impact)
      },
      {
        title: 'Corrective action',
        content: addActionContent('Add corrective action', problem.corrective_action)
      },
      {
        title: 'Preventive action',
        content: addActionContent('Add preventive action', problem.preventive_action)
      },
      {
        title: 'Outcome',
        content: addActionContent('Add outcome', problem.outcome)
      }
    ]

    if (problem.status === 'Rejected') { problemDetails.push({ title: 'Reject reason', content: problem.reject_reason }) }

    return (
      <section className="card content-section" style={hidden ? { display: 'none' } : {}}>
        <div key="header" className="content-section__header-tabs-container">
          {contentSectionHeaderTabs}
        </div>

        <div style={currentContentSectionTab === 'Problem' ? {} : { display: 'none' }}>
          <div key="problem" className="content-section__content">
            <div className="content-section__options">
              <h4 className="content-section__title content-section__title--no-margin" />
              { canEditProblem &&
                (
                  <button type="button" className="button-link link link--decorated" onClick={() => this.setEditModalVisible(true)}>
                    edit
                  </button>
                )
              }
            </div>
            <DetailList
              list={_.map(problemDetails, ({ title, content }) => ({ title, content }))}
            />

            <br />
            <hr />

            <DetailList
              list={_.map(problemActionDetails, ({ title, content }) => ({ title, content }))}
            />

            {canEditProblem &&
              (
                <EditModal
                  {...{
                    showEditModal,
                    errorMessage,
                    priority,
                    fields,
                    errors,
                    submitButton,
                    priorities,
                    categories,
                    majorIncidentManagers,
                    technicalEngineers,
                    managers,
                    usersOptions,
                    problem_manager_id,
                    datacentres
                  }}
                  setEditModalVisible={v => this.setEditModalVisible(v)}
                  handlePriorityChange={v => this.handlePriorityChange(v)}
                  setFieldErrorClasses={v => this.setFieldErrorClasses(v)}
                  handleInput={(f, v) => this.handleInput(f, v)}
                  handleMultiSelect={(field, value) => this.setState({ [field]: value })}
                  submit={() => this.submit()}
                />
              )
            }
          </div>
          <hr />
          <div key="attachments" className="content-section__content">
            <Attachments
              object={problem}
              admin={policies.problem.attachmentAdmin}
            />
          </div>
        </div>

        <div key="problemHistory" className="content-section__content" style={currentContentSectionTab === 'Problem history log' ? {} : { display: 'none' }}>
          {_.map(history, ({ title, content, created_at: createdAt }) => (
            <ConversationItem
              type="comment"
              direction="outgoing"
              name={title}
              time={createdAt}
            >
              {content}
            </ConversationItem>
          ))}
        </div>
      </section>
    )
  }
}

ProblemDetails.propTypes = {
  paths: PropTypes.shape({
    problemPath: PropTypes.string.isRequired
  }).isRequired,
  hidden: PropTypes.bool,
  setAlert: PropTypes.func.isRequired,
  updateProblem: PropTypes.func.isRequired,
  priorities: PropTypes.array.isRequired,
  policy: PropTypes.func.isRequired,
  problem: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired
}

ProblemDetails.defaultProps = {
  hidden: false
}

export default ProblemDetails
